import React, { useState, useEffect } from "react"; 
import { Form } from "react-bootstrap";
import { Eye, EyeOff } from "lucide-react";
import { API_CODECS_LIST, API_OPERATORS_LIST, API_SERVER_MANAGEMENT_LIST } from "../../../service/url";
import { getApiCall } from "../../../service/httpCall";
import { toast } from 'react-toastify';
import {
  TRUNK_AUTH_TYPES,
  OPERATOR_TYPES,
  CONTENT_STATUS,
  TRUNK_AUTH_TYPE_IP,
  TRUNK_AUTH_TYPE_REGISTRATION,
} from "../../../utilities/constant";

function RenderAuthenticationFields(props) {
  props = props["props"];
  const [showPassword, setShowPassword] = useState(false);

  const normalizedAuthType =
  typeof props.authType === "string"
    ? TRUNK_AUTH_TYPES.find(
        (x) =>
          x.label.toLowerCase() === props.authType.toLowerCase() ||
          String(x.value) === props.authType
      )?.value
    : props.authType;

  if (normalizedAuthType === TRUNK_AUTH_TYPE_IP) {
    return (
      <Form.Group className="col-md-12 form-group">
        {/* {props.isEditMode &&  */}
        <Form.Label htmlFor="identify_by">Identify By: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
        {/* } */}
        <Form.Control
  type="text"
  placeholder="Enter valid IPv4"
  value={props.ipIdentifyBy}
  onChange={(e) => {
    const value = e.target.value.replace(/[^0-9.]/g, "");
    props.setIpIdentifyBy(value);
  }}
  onBlur={() => {
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;

    if (props.ipIdentifyBy && !ipRegex.test(props.ipIdentifyBy)) {
       toast.error("Invalid IPv4 address");
      props.setIpIdentifyBy("");
    }
  }}
  required
/>
      </Form.Group>
    );
  } else if (normalizedAuthType === TRUNK_AUTH_TYPE_REGISTRATION) {
    return (
      <>
        <Form.Group className="col-md-6 form-group">
          {props.isEditMode && <Form.Label htmlFor="username">Authentication username:</Form.Label>}
  <Form.Control
  type="text"
  placeholder="Username"
  value={props.authUsername}
  onChange={(e) => {
    const value = e.target.value;
    if (/^[A-Za-z0-9]*$/.test(value)) {
      props.setAuthUsername(value);
    }
  }}
  onBlur={() => {
    if (!props.authUsername || !props.authUsername.trim()) {
       toast.error("Username cannot be empty");
    }
  }}
  required
/>
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {props.isEditMode &&  <Form.Label htmlFor="password">Authentication password:</Form.Label>}
         <Form.Control
        type={showPassword ? "text" : "password"}
        value={props.authPassword}
        onChange={(e) => props.setAuthPassword(e.target.value)}
      />

      <span
        onClick={() => setShowPassword(!showPassword)}
        style={{ cursor: "pointer" }}
      >
       {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
      </span>
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
        {props.isEditMode && <Form.Label htmlFor="server_url">
            Authentication server url:
          </Form.Label>}
          <Form.Control
            type="text"
            placeholder="Authentication server url:"
            id="server_url"
            maxLength={100}
            value={props.authServerUrl}
            onChange={(e) => props.setAuthServerUrl(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
        {props.isEditMode && <Form.Label htmlFor="client_url">
            Authentication client url:
          </Form.Label>}
          <Form.Control
            type="text"
            id="client_url"
            placeholder="Authentication client url:"
            maxLength={100}
            value={props.authClientUrl}
            onChange={(e) => props.setAuthClientUrl(e.target.value)}
            required
          />
        </Form.Group>
      </>
    );
  }

  return <></>;
}

export default function RenderTrunkForm(props) {

  const [codecsList, setCodecsList] = useState([]);
  const [operatorsList, setOperatorsList] = useState([]);
  const [serverList, setServerList] = useState([]);

  useEffect(() => {
    getApiCall(API_CODECS_LIST, {}).then(onCodecsListSuccess).catch(onError);

    getApiCall(API_OPERATORS_LIST, {})
      .then(onOperatorListSuccess)
      .catch(onError);

      getApiCall(API_SERVER_MANAGEMENT_LIST, {})
      .then(onServerListSuccess)
      .catch(onError);  
  }, []);

  function onCodecsListSuccess(resp) {
    setCodecsList(resp);
  }

  function onOperatorListSuccess(resp) {
    setOperatorsList(resp);
  }

  function onServerListSuccess(resp) {
    setServerList(resp);
}

  function onError(err) {
    console.log(err);
  }

  const selectedAuthTypeValue = props.isEditMode
  ? TRUNK_AUTH_TYPES.find(
      (x) => x.label.toLowerCase() === (props.authType || "").toLowerCase()
    )?.value
  : props.authType;


  return (
    <>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode &&  */}
          <Form.Label htmlFor="name">Name: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* } */}
          <Form.Control
            type="text"
            id="name"
            placeholder="Name"
            maxLength={100}
            value={props.name}
            onChange={props.handleChange}
            required
          />
          {props.error && <small style={{ color: "red" }}>{props.error}</small>}
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="auth_type">Authentication Type:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Select
            id="auth_type"
            className="p-2"
            required
            value={selectedAuthTypeValue}
            onChange={(e) => {
              if (props.isEditMode) {
                const selectedLabel = TRUNK_AUTH_TYPES.find((x) => x.value === Number(e.target.value))?.label;
                props.setAuthType(selectedLabel || "");
              } else {
                props.setAuthType(e.target.value);
              }
            }}
          >
            <option value={""}>Select Authentication Type</option>
            {TRUNK_AUTH_TYPES.map((val) => (
              <option key={val.value} value={val.value}>
                {val.label}
              </option>
           ))}
          </Form.Select>
        </Form.Group>
      </div>
      <div className="row">
        <RenderAuthenticationFields props={props} />
      </div>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="domain">Domain:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
<Form.Control
  type="text"
  id="domain"
  maxLength={200}
  value={props.domain}
  placeholder="https://example.com"
  onChange={(e) => {
    const value = e.target.value.trim();

    // Allow valid URL characters while typing
    if (/^[a-zA-Z0-9:/.-]*$/.test(value)) {
      props.setDomain(value);
    }
  }}
  onBlur={() => {
    const domainRegex =
      /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    if (props.domain && !domainRegex.test(props.domain)) {
      toast.error("Domain must start with http:// or https://");
      props.setDomain("");
    }
  }}
  required
/>
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="port">Port Number:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
<Form.Control
  type="text"
  id="port"
  placeholder="Port (1024 - 65535)"
  maxLength={5}
  value={props.port}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");

    if (value.length <= 5) {
      props.setPort(value);
    }
  }}
  onBlur={() => {
    const portNumber = Number(props.port);

    if (
      !Number.isInteger(portNumber) ||
      portNumber < 1024 ||
      portNumber > 65535
    ) {
      toast.error("Port must be between 1024 and 65535");
      props.setPort("");
    }
  }}
  required
/>
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group className="col-md-6 form-group" placeholder="Select codecs">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="codecs">Select codecs: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Select
            id="codecs"
            className="p-2"
            required
            value={props.codec}
            onChange={(e) => props.setCodec(e.target.value)}
          >
            <option value={""}>Select codec</option>
            {codecsList.map(function (val, idx) {
              return (
                <option key={idx} value={val.id}>
                  {val.name}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="piolt_number">Pilot Number: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
<Form.Control
  type="text"
  id="pilot_number"
  maxLength={10}
  value={props.pilotNumber}
  placeholder="Pilot Number (max 10 digits)"
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");

    if (value.length <= 10) {
      props.setPilotNumber(value);
    }
  }}
  required
/>
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="operator">Select Operator: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Select
            id="operator"
            className="p-2"
            required
            value={props.operator}
            onChange={(e) => props.setOperator(e.target.value)}
          >
            <option value={""}>Select Operator</option>
            {operatorsList.map(function (val, idx) {
              return (
                <option key={idx} value={val.id}>
                  {val.name}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="chanels">Channels: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Control
            type="number"
            id="chanels"
            placeholder="Channels"
            min={0}
            max={10000}
            value={props.channels}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || (value >= 0 && value <= 10000)) {
                props.setChannels(value);
              }
            }}
            required
          />
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="cps">Calls per sec: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Control
            type="number"
            id="cps"
            placeholder="Calls pers sec"
            min={0}
            max={1000}
            value={props.cps}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || (value >= 0 && value <= 1000)) {
                props.setCps(value);
              }
            }}
            required
          />
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="status">Status: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Select
            id="status"
            className="p-2"
            required
            value={props.status}
            onChange={(e) => props.setStatus(e.target.value)}
          >
            <option value={""}>Status</option>
            {CONTENT_STATUS.map(function (val, idx) {
              return (
                <option key={idx} value={val.value}>
                  {val.label}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
      </div>
      <div className="row">
                <Form.Group className="col-md-6 form-group">
                {/* {props.isEditMode && ( */}
                   <Form.Label htmlFor="server">Gateway: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                    {/* )} */}
                    <Form.Select id="operator" required value={props.server} className="p-2" onChange={e => props.setServer(e.target.value)}>
                        <option value={''}>Select Gateway</option>
                        {
                            serverList.map(function (val, idx) {
                                return (<option key={idx} value={val.id}>{val.server_name}</option>)
                            })
                        }
                    </Form.Select>
                </Form.Group>
            </div>
    </>
  );
}
